import getMessageAvertissement from '@/services/devisCommandes/optionBlocage/getMessageAvertissement';

import { updateAffectionOfAllProduct } from '@/services/affectation/affectation';
import { REGROUPEMENT } from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import { updateAffectationProduitTempoFromDevis } from '@/services/affectation/updateAffectationProduitTempoFromDevis';
import initializeCommandeDevis from '@/services/devisCommandes/initializeCommandeDevis';

export default async function updateInformationDevisAsync(devisWithNewData) {
  getMessageAvertissement(devisWithNewData);

  devisWithNewData.lignesCommande
    .filter((ligne) => {
      return ligne.type === REGROUPEMENT && ligne.typeProduit === CATEGORIE_REGROUPEMENT;
    })
    .forEach((ligneReseauTempo) => {
      ligneReseauTempo.etatDeLaDemande = false;
    });
  await updateAffectionOfAllProduct(devisWithNewData);
  await updateAffectationProduitTempoFromDevis(devisWithNewData);
  initializeCommandeDevis(devisWithNewData);
  return devisWithNewData;
}
